import axios from "axios";
import { buildApiUrl } from "@/utils/api";

interface StringPayload {
  [key: string]: string;
}

/**
 * @description Network request to get keys from proxy server. Returns decoded keys as object for access.
 * @param keyString - String of keys to be requested from proxy server. Multiple values can be comma seperated. IE: 'KEY_ONE,KEY_TWO'
 * @param abort - Abort controller for request cancel tracking
 * @return returns object of requested keys
 *    IE: { KEY_ONE: 'value', KEY_TWO: 'value' }
 */
export const retrieveKeys = (
  keyString: string,
  abort: AbortController,
): Promise<StringPayload> => {
  return axios
    .get<string>(buildApiUrl(`access?keys=${keyString}`), {
      signal: abort.signal,
    })
    .then((json): StringPayload => {
      return JSON.parse(atob(json.data)) as StringPayload;
    });
};
